import { useState } from "react";
import { toast } from "sonner";
import { Send, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsletterForm({ variant = "light" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, name });
      toast.success(data.message || "Inscription confirmée");
      setEmail("");
      setName("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "dark";

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className={`rounded-2xl p-6 md:p-8 relative overflow-hidden ${
        dark ? "bg-[#2E4959] text-white border border-white/10" : "bg-white border border-[#DDE3E8] jt-soft-shadow"
      }`}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className={`h-11 w-11 rounded-full flex items-center justify-center ${dark ? "bg-white/10" : "bg-[#E4EBEF]"}`}>
          <Mail className="w-5 h-5 text-[#4A6D82]" strokeWidth={1.75} />
        </div>
        <div>
          <h4 className={`font-serif text-2xl leading-tight ${dark ? "text-white" : "text-[#1E2933]"}`}>Newsletter</h4>
          <p className={`text-sm ${dark ? "text-white/70" : "text-[#6B7A85]"}`}>Reçois nos nouveautés et méditations dans ta boîte.</p>
        </div>
      </div>

      <div className="grid gap-3 sm:grid-cols-[1fr_1fr_auto]">
        <input data-testid="newsletter-name" type="text" placeholder="Prénom (optionnel)" value={name} onChange={(e) => setName(e.target.value)}
          className={`px-4 py-3 rounded-full text-sm focus:ring-2 focus:ring-[#4A6D82] ${dark ? "bg-white/10 placeholder:text-white/40 text-white border border-white/10" : "bg-[#F7F5F0] border border-[#DDE3E8]"}`} />
        <input data-testid="newsletter-email" type="email" required placeholder="Ton email" value={email} onChange={(e) => setEmail(e.target.value)}
          className={`px-4 py-3 rounded-full text-sm focus:ring-2 focus:ring-[#4A6D82] ${dark ? "bg-white/10 placeholder:text-white/40 text-white border border-white/10" : "bg-[#F7F5F0] border border-[#DDE3E8]"}`} />
        <button data-testid="newsletter-submit" disabled={loading} type="submit"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#4A6D82] text-white text-sm hover:bg-[#2E4959] transition disabled:opacity-60 jt-blue-glow">
          <Send className="w-4 h-4" />
          {loading ? "..." : "S'inscrire"}
        </button>
      </div>
    </form>
  );
}
